import styled from "styled-components";
import Carousel from "@davistran86/carousel";
import React from "react";
const images = [
  "https://images.unsplash.com/photo-1573502721625-c482d1bc3935?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=810&q=80",
  "https://images.unsplash.com/photo-1573410559174-2656f13bf3f8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=810&q=80",
  "https://images.pexels.com/photos/1699030/pexels-photo-1699030.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=810",
  "https://images.unsplash.com/photo-1542916514-3e2119eefeb7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=810&q=80"
];

const Container = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    width: 100%;
    height: 100vh;
  }
`;

const RightContainer = props => {
  return (
    <Container>
      <Carousel height="80%" indicatorsColor="white">
        {images.map((image, index) => {
          return <img key={index} alt={image.author} src={image} />;
        })}
      </Carousel>
    </Container>
  );
};

export default RightContainer;
